<template>
<div class="form">
<a-card size="small" :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="channelcode" label="渠道编码" prop="channelcode">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.channelcode"
                     @blur="
                        () => {
                            $refs.channelcode.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.channelcode}}</span>
            </a-form-model-item>

            <a-form-model-item ref="channelname" label="渠道名称" prop="channelname">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.channelname"
                     @blur="
                        () => {
                            $refs.channelname.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.channelname}}</span>
            </a-form-model-item>

            <a-form-model-item ref="platformname" label="平台" prop="platformname">
                <platformSelecter :isDisabled="!is_vue_task" :showAll="false" v-model="record.platformtype"></platformSelecter>
            </a-form-model-item>

            <a-form-model-item ref="status" label="渠道状态" prop="status">
                <a-radio-group v-if="is_vue_task" v-model="record.status">
                    <a-radio value="02">
                    开启
                    </a-radio>
                    <a-radio value="01">
                    未开启
                    </a-radio>
                </a-radio-group>
                <span v-else-if="record.status == '01'">未开启</span>
                <span v-else-if="record.status == '02'">开启</span>

            </a-form-model-item>

            <a-form-model-item label="修改信息" v-if="!is_new">
                    创建时间 ：<span>{{record.createtime}}</span>
                    创建人:<span>{{record.createuser}}</span>
                    <br>
                    更新时间: <span>{{record.updatetime}}</span>
                    更新人: <span>{{record.updatetuser}}</span>
            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 8 }" >
                <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>

</template>
<script>
const m_title = {
    'add_channel':'新增渠道',
    'detail_channel':'查看渠道',
    'edit_channel':'编辑渠道',
};
import platformSelecter from '../../components/platformSelecter'
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                channelname: [
                    { required: true, message: ' 请输渠道名称 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                channelcode:[
                    { required: true, message: ' 请输渠道编码 ', trigger: 'blur' },

                ]
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                channelcode:'',
                channelname:'',
                platformtype:'',
                status:'02',
                createtime:'',
                createuser:'',
                updatetime:'',
                updatetuser:''
            }
        };
    },
    components:{
        platformSelecter
    },
    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'edit_channel'){
                        that.$store
                            .dispatch({
                                type: "mcmsmanager/updatechannel",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add_channel'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "mcmsmanager/addchannel",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        triggerValidate(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(valid)
                }
            })
            this.confirmLoading = false;

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.channelcode = 'CHANNEL-000'
        },

        getDetail(id){
            this.$store.dispatch({
                type: "mcmsmanager/querychannelone",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_channel";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_channel'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
